import React from 'react';
import {NavLink} from 'react-router-dom';

export const Nav = () => {
    return (
        <nav className="navbar navbar-default navbar-static-top">
            <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div id="navbar" className="collapse navbar-collapse">
                        <ul className="nav navbar-nav">
                            <li><NavLink exact  to="/">Home</NavLink></li>
                            <li><NavLink  to="/location">Location</NavLink></li>
                            <li><NavLink  to="/about">About</NavLink></li>
                        </ul>
                   </div>
            </div>
        </nav>
    );
}


// WEBPACK FOOTER //
// ./src/components/Nav.js